import { render } from "./TemplatesGeneral.vue?vue&type=template&id=7255d75f"
import script from "./TemplatesGeneral.vue?vue&type=script&lang=js"
export * from "./TemplatesGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__